module.exports = __webpack_public_path__ + "static/plum-9e9f3a8f0edfa620f4d03c80dec1379a.svg";